import React from 'react';
import { CardContent, Grid } from '@mui/material';
import { formatCurrency } from 'common/constants/currency';
import { useStoreSelector } from 'v3/data/store';
import { PaymentStatus } from 'v3/pages/OnlineContracting/Details/Cards/TransactionInformation/PaymentStatus';
import { getChannelLabel } from 'v3/shared/components/Table/OnlineContractingTable/statusHelpers';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import {
  BodySmallRegularStyled,
  CardHeaderStyled,
  CardStyled,
  Content,
  TextBreakable,
} from '../styles';

export const OnlineTransactionInformation = () => {
  const { paymentDetails } = useStoreSelector((store) => store.onlineContracting);

  return (
    <CardStyled>
      <CardHeaderStyled
        title={
          <Content>
            <SubtitleLarge>Transação</SubtitleLarge>
          </Content>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>ID do pedido</BodySmallRegularStyled>
            <TextBreakable>
              <BodySmallRegular className="empty-line">{paymentDetails?.orderId || ''}</BodySmallRegular>
            </TextBreakable>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>ID do pagamento</BodySmallRegularStyled>
            <TextBreakable>
              <BodySmallRegular className="empty-line">{paymentDetails?.paymentId || ''}</BodySmallRegular>
            </TextBreakable>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>Valor da entrada</BodySmallRegularStyled>
            <BodySmallRegular className="empty-line">
              {paymentDetails?.downpaymentValue ? formatCurrency(paymentDetails.downpaymentValue) : 'R$ 0,00'}
            </BodySmallRegular>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>Canal</BodySmallRegularStyled>
            <BodySmallRegular className="empty-line">{getChannelLabel(paymentDetails?.origin)}</BodySmallRegular>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>Status</BodySmallRegularStyled>
            <PaymentStatus status={paymentDetails?.paymentStatus} />
          </Grid>
        </Grid>
      </CardContent>
    </CardStyled>
  );
};
